import { Skeleton } from "@heroui/react";

const TrackAssetLoader = ({ count = 2 }) => {
  const SkeletonItem = () => (
    <div className="flex gap-6 flex-col lg:flex-row lg:items-center">
      <div className="flex items-center gap-4 lg:max-w-md xl:max-w-lg">
        <div className="c-image flex-shrink-0">
          <Skeleton className="w-[5rem] h-[5rem] sm:w-[6rem] sm:h-[6rem] rounded-xl" />
        </div>
        <Skeleton className="h-6 rounded-lg max-w-[200px] sm:max-w-[250px] lg:max-w-[300px]" />
      </div>

      <ol className="hidden sm:grid grid-cols-4 flex-1 desktop-order-track">
        {[1, 2, 3, 4].map((item) => (
          <li
            key={item}
            className="flex flex-col items-center gap-3 relative order-track"
          >
            <Skeleton className="h-4 w-20 rounded" />
            <Skeleton className="rounded-full w-6 h-6" />
            <Skeleton className="h-3 w-16 rounded" />
          </li>
        ))}
      </ol>

      <ol className="sm:hidden mob-order-track-wrapper">
        {[1, 2, 3, 4].map((item) => (
          <li key={item} className="flex pb-6 gap-4 relative mob-order-track">
            <Skeleton className="rounded-full w-6 h-6 flex-shrink-0" />
            <div className="flex flex-col gap-2 w-[calc(100%-2.5rem)]">
              <Skeleton className="h-4 w-32 rounded" />
              <Skeleton className="h-3 w-24 rounded" />
            </div>
          </li>
        ))}
      </ol>
    </div>
  );

  return (
    <div className="flex gap-2 my-6 p-4 border border-[#C2C2C2] rounded-2xl">
      <div className="w-full flex flex-col gap-6">
        {Array.from({ length: count }).map((_, index) => (
          <SkeletonItem key={index} />
        ))}
      </div>
    </div>
  );
};

export default TrackAssetLoader;
